import { motion } from "framer-motion";
import { Button } from "@nextui-org/react";
import { Link } from "react-scroll";
import BlurImage from "../../components/BlurImage";

const stagger = {
  animate: {
    transition: { staggerChildren: 0.15 },
  },
};

const fadeUp = {
  initial: { opacity: 0, y: 30 },
  animate: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
};

const letterVariant = {
  initial: { opacity: 0, y: 50 },
  animate: (i) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.04, duration: 0.5, ease: "easeOut" },
  }),
};

function AnimatedHeading({ className }) {
  return (
    <h1 className={className}>
      {"Hey, I'm ".split("").map((char, i) => (
        <motion.span
          key={i}
          custom={i}
          variants={letterVariant}
          initial="initial"
          animate="animate"
          className="inline-block"
        >
          {char === " " ? "\u00A0" : char}
        </motion.span>
      ))}
      <br />
      {"Angelo".split("").map((char, i) => (
        <motion.span
          key={i + 20}
          custom={i + 20}
          variants={letterVariant}
          initial="initial"
          animate="animate"
          className="inline-block"
        >
          {char === " " ? "\u00A0" : char}
        </motion.span>
      ))}
    </h1>
  );
}

export default function HeroSection() {
  return (
    <section id="heroSection" className="relative min-h-screen flex items-center overflow-hidden pt-20 bg-white dark:bg-black">
      <div className="section-container w-full">
        <motion.div
          initial="initial"
          animate="animate"
          variants={stagger}
          className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center"
        >
          <motion.div variants={fadeUp} className="lg:col-span-7 space-y-6">
            <p className="font-body text-sm md:text-base font-medium text-black/40 dark:text-white/40 uppercase tracking-widest">
              Software Developer
            </p>

            <AnimatedHeading
              className="font-display text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-bold text-black dark:text-white leading-[1.1] tracking-tight"
            />

            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 1.2, duration: 0.6 }}
              className="font-body text-lg md:text-xl text-black/50 dark:text-white/50 max-w-xl leading-relaxed"
            >
              A software developer with a passion for crafting robust and efficient
              solutions. I thrive on tackling complex challenges and turning ideas
              into scalable applications.
            </motion.p>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 1.5, duration: 0.5 }}
              className="flex gap-4 pt-4"
            >
              <Button
                as={Link}
                to="MyPortfolio"
                spy={true}
                smooth={true}
                offset={-60}
                duration={500}
                size="lg"
                className="font-body font-semibold bg-black text-white dark:bg-white dark:text-black
                           px-8 py-6 rounded-xl hover:bg-black/80 dark:hover:bg-white/80
                           transition-all duration-200 cursor-pointer"
              >
                View My Work
              </Button>
              <Button
                as={Link}
                to="Contact"
                spy={true}
                smooth={true}
                offset={-60}
                duration={500}
                size="lg"
                variant="bordered"
                className="font-body font-semibold border-2 border-black/20 dark:border-white/20
                           text-black dark:text-white px-8 py-6 rounded-xl
                           hover:bg-black/5 dark:hover:bg-white/5 transition-all duration-200 cursor-pointer"
              >
                Get In Touch
              </Button>
            </motion.div>
          </motion.div>

          <motion.div
            variants={fadeUp}
            className="lg:col-span-5 flex justify-center lg:justify-end"
          >
            <div className="relative">
              <div className="relative w-72 h-72 md:w-80 md:h-80 lg:w-96 lg:h-96 rounded-3xl overflow-hidden border-2 border-black/10 dark:border-white/10 shadow-2xl glass">
                <BlurImage
                  src="./img/taruc.png"
                  alt="Angelo"
                  className="w-full h-full"
                />
              </div>
              <div className="absolute -top-4 -right-4 w-24 h-24 border-2 border-black/10 dark:border-white/10 rounded-full" />
              <div className="absolute -bottom-4 -left-4 w-16 h-16 border-2 border-black/10 dark:border-white/10 rounded-full" />
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
